import React, { useEffect, useState } from "react";
import {
  AdminPanel,
  Logo,
  Resource,
  SultanLogo,
} from "../../assets/icons/Icons";
import { useNavigate } from "react-router-dom";
import SidebarButton from "../atoms/buttons/SidebarButton";
import { getRouteSegment } from "../../lib/utils/funcs";
import { mainItems, supportItems } from "../../assets/data/sidebar";
import { useHospDocData } from "../../lib/contexts/HospitalDoctorContext";
import { AdminPanelHover, ResourceHover } from "../../assets/icons/HoverIcons";
import { useUserData } from "../../lib/contexts/UserContext";
import { LiaFilePrescriptionSolid } from "react-icons/lia";
import { useFeatureFlags } from "../../lib/contexts/FeatureFlagContext";

import { FaRegUserCircle, FaYoutube, FaWhatsapp } from "react-icons/fa";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { gunasheelaHidingDetails } from "../../lib/utils/constants";
import { getWaLeads } from "../../lib/apis/waLeads";
import { format } from "date-fns";

const Sidebar = () => {
  const [isHovered, setIsHovered] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [waLeadsCount, setWaLeadsCount] = useState(0);

  const navigate = useNavigate();
  const { hospitalID, hospData } = useHospDocData();
  const { userData } = useUserData();
  const { prescription, wa_lead_collection_via_dropoffs } = useFeatureFlags();

  useEffect(() => {
    if (
      (userData?.role === "MasterAdmin" || userData?.role === "Trial") &&
      mainItems.filter((e) => e.name === "Resources").length === 0
    ) {
      mainItems.splice(3, 0, {
        name: "Resources",
        icon: <Resource style={"md:w-5 lg:w-6"} />,
        hoverIcon: <ResourceHover style={"md:w-5 lg:w-6"} />,
      });
    }
    if (
      userData?.role === "MasterAdmin" &&
      mainItems.filter((e) => e.name === "Admin Panel").length === 0
    ) {
      mainItems.splice(1, 0, {
        name: "Admin Panel",
        icon: <AdminPanel style={"md:w-5 lg:w-6"} />,
        hoverIcon: <AdminPanelHover style={"md:w-5 lg:w-6"} />,
      });
    }
    if (
      (userData?.role === "MasterAdmin" || userData?.role === "Doctor") &&
      mainItems.filter((e) => e.name === "Analytics").length === 0
    ) {
      mainItems.splice(1, 0, {
        name: "Analytics",
        icon: <AdminPanel style={"md:w-5 lg:w-6"} />,
        hoverIcon: <AdminPanelHover style={"md:w-5 lg:w-6"} />,
      });
    }
    if (
      prescription &&
      (userData?.role === "Doctor" || userData?.role === "MasterAdmin") &&
      mainItems.filter((e) => e.name === "Create Prescription").length === 0
    ) {
      const appointmentsIndex = mainItems.findIndex(
        (item) => item.name === "Appointments"
      );
      const insertIndex = appointmentsIndex !== -1 ? appointmentsIndex + 1 : 3;
      mainItems.splice(insertIndex, 0, {
        name: "Create Prescription",
        icon: <LiaFilePrescriptionSolid className={"w-6 h-6 md:w-6 md:h-6"} />,
        hoverIcon: <LiaFilePrescriptionSolid className={"md:w-6 md:h-6"} />,
      });
    }
    if (
      wa_lead_collection_via_dropoffs &&
      mainItems.filter((e) => e.name === "WA Leads").length === 0
    ) {
      mainItems.push({
        name: "WA Leads",
        icon: <FaWhatsapp className="w-6 h-6 text-green-600" />,
        hoverIcon: <FaWhatsapp className="w-6 h-6 text-green-600" />,
      });
    }
  }, [userData, hospitalID, prescription, wa_lead_collection_via_dropoffs]);

  // Fetch open WA leads count
  const fetchWaLeadsCount = async () => {
    if (!hospitalID || !wa_lead_collection_via_dropoffs) return;
    try {
      const dateStr = format(new Date(), "yyyy-MM-dd");
      const res = await getWaLeads(hospitalID, dateStr, 1, 1, "open");
      if (res?.status === 200) {
        const result = res.data?.result || res.data?.data || res.data;
        if (result?.pagination?.totalRecords != null) {
          setWaLeadsCount(result.pagination.totalRecords);
        } else if (result?.count != null) {
          setWaLeadsCount(result.count);
        } else if (Array.isArray(result)) {
          const first = result[0];
          setWaLeadsCount(first?.count || first?.leads?.length || result.length || 0);
        }
      }
    } catch {}
  };

  useEffect(() => {
    fetchWaLeadsCount();
    const interval = setInterval(fetchWaLeadsCount, 15 * 60 * 1000);
    // Listen for updates from WaLeads page
    const handleUpdate = () => fetchWaLeadsCount();
    window.addEventListener("wa-leads-updated", handleUpdate);
    return () => {
      clearInterval(interval);
      window.removeEventListener("wa-leads-updated", handleUpdate);
    };
  }, [hospitalID, wa_lead_collection_via_dropoffs]);

  // Filter out "Patients" for restricted Receptionists
  const isRestrictedUser =
  userData?.role === "FloorReceptionist" ||
  (userData?.role === "Receptionist" &&
    gunasheelaHidingDetails.includes(hospitalID || ""));

  const filteredMainItems = isRestrictedUser
  ? mainItems.filter((item) => item.name !== "Patients")
  : mainItems;

  return (
    <div
      className={`bg-white hidden xl:flex xl:flex-col ${
        isCollapsed ? "w-20" : "w-1/5"
      } min-h-screen px-2 border-solid border-e-[1px] border-sbBorder h-[100vh] overflow-y-auto side_bar_prescription transition-all duration-300`}
    >
      <div
        className={`mt-3 cursor-pointer flex justify-between items-center ${
          isCollapsed ? "px-0 flex-col-reverse" : "px-4"
        }`}
      >
        <div onClick={() => navigate("/" + hospitalID + "/dashboard")}>
          {hospitalID === "f6378aa4-0b3c-42e3-be8f-bb8b85f256c0" ? (
            <SultanLogo
              style={isCollapsed ? "md:w-10 lg:w-12" : "md:w-28 lg:w-[140px]"}
            />
          ) : hospData?.is_easy_heal ? (
            <img
              src={require("../../assets/images/easyHealsLogo.jpg")}
              className={
                isCollapsed ? "md:w-10 lg:w-12" : "md:w-28 lg:w-[150px]"
              }
              alt="EasyHeals"
            />
          ) : isCollapsed ? (
            <img
              src="https://ik.imagekit.io/deepu/DTLOGO.png?updatedAt=1752144633211"
              className="w-full mt-2 rounded-lg"
              alt="DocTrue"
            />
          ) : (
            <Logo style="md:w-28 lg:w-[150px]" />
          )}
        </div>

        <button
          className={`bg-white border border-sbBorder rounded-lg shadow p-1 hover:bg-gray-100 transition-all ${
            isCollapsed ? "w-full h-8" : "w-10 h-full"
          } flex justify-center items-center mt-0 md:mt-2`}
          style={{ transform: isCollapsed ? "rotate(180deg)" : "none" }}
          onClick={() => setIsCollapsed((prev) => !prev)}
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
      </div>
      <div className="mt-8 flex flex-col">
        {!isCollapsed && (
          <p className="ml-5 uppercase font-medium md:text-[9px] lg:text-[11px] mb-1">
            Main
          </p>
        )}
        <div className="flex flex-col">
          {(userData?.role === "Doctor"
            ? filteredMainItems.map((item) =>
                item.name === "Doctors"
                  ? {
                      name: "Profile",
                      icon: <FaRegUserCircle className="w-6 h-6" />,
                      hoverIcon: <FaRegUserCircle className="w-6 h-6" />,
                    }
                  : item
              )
            : filteredMainItems
          ).map((item, index) => (
            <SidebarButton
              key={index}
              index={index}
              isHovered={isHovered}
              setIsHovered={setIsHovered}
              name={item.name}
              icon={item.icon}
              hoverIcon={item.hoverIcon}
              onPress={() => {
                const routeName = item.name
                  .toLowerCase()
                  .replace(/[^a-z0-9]/g, "");
                navigate(hospitalID + "/" + routeName);
              }}
              isSelected={
                getRouteSegment(2) ===
                item.name.toLowerCase().replace(/[^a-z0-9]/g, "")
              }
              isCollapsed={isCollapsed}
              rightIcon={
                item.name === "WA Leads" && waLeadsCount > 0
                  ? <span className="relative -top-3 -right-2 animate-bounce bg-blue-500 text-white text-[9px] font-bold w-5 h-5 flex items-center justify-center rounded-md shadow-sm">{waLeadsCount}</span>
                  : undefined
              }
            />
          ))}
        </div>
      </div>
      <div className="mt-8 flex flex-col">
        {!isCollapsed && (
          <p className="ml-5 uppercase font-medium md:text-[9px] lg:text-[11px] mb-1">
            Support
          </p>
        )}
        <div className="flex flex-col">
          {supportItems.map((item, index) => (
            <SidebarButton
              key={index}
              index={index}
              isHovered={isHovered}
              setIsHovered={setIsHovered}
              name={item.name}
              icon={item.icon}
              hoverIcon={item.hoverIcon}
              onPress={() => {
                navigate(
                  hospitalID + "/" + item.name.toLowerCase().split(" ")[0]
                );
              }}
              isSelected={
                getRouteSegment(2) === item.name.split(" ")[0].toLowerCase()
              }
              isCollapsed={isCollapsed}
            />
          ))}
        </div>
      </div>

      <a
        href="https://www.youtube.com/playlist?list=PLbQxMkdQD7qDJun4vhI0Drognf0XWu7aY"
        target="_blank"
        rel="noopener noreferrer"
        className={`${isCollapsed ? "flex justify-center" : ""}`}
      >
        <button
          className={`group
             flex items-center justify-center
             font-sans text-lg
             bg-gradient-to-b from-[#0F3CBE]/100 to-[#1a4fd4]/90
             text-white
             py-2 px-5
             rounded-full
             shadow-lg
             mb-6
             mt-3
             transform transition-all duration-300
             hover:-translate-y-1 hover:shadow-lg
             active:scale-95 active:shadow-sm
             ${isCollapsed ? "w-12 h-12 p-0 ml-2" : "ml-3"}`}
        >
          <div
            className={`flex items-center justify-center
               rounded-full
               bg-white/20
               transition-all duration-300
               group-hover:bg-white/50
               ${isCollapsed ? "w-8 h-8 !bg-transparent" : "w-8 h-8 mr-2"}`}
          >
            <svg
              className={`fill-current
          transition-transform duration-500 ease-in-out
          origin-center group-hover:rotate-45 ${
            isCollapsed ? "w-6 h-6" : "w-4 h-4 "
          }`}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z" />
            </svg>
          </div>
          {!isCollapsed && (
            <span className="block text-[1rem] font-[Inter] transition-all text-left duration-300">
              Tutorial
            </span>
          )}
        </button>
      </a>

      {/* {userData?.role === "Trial" && (
        <div>
          <iframe
            className="w-[14%] h-[20%] rounded-xl fixed top-[78%]"
            src="https://www.youtube.com/embed/ou0phHbzz-0?si=c_1f4IoINOEKHybX"
            title="Demo Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      )} */}
    </div>
  );
};

export default Sidebar;
